import { useEmbeddedOnboardingContext } from 'pages/employer_onboarding/EmbeddedOnboardingProvider'

export const useEmbeddedOnboarding = () => {
  return useEmbeddedOnboardingContext()
}
